import { CollectionEntity } from "@busy-human/gearbox";
export var Tasks;
(function (Tasks) {
    let Status;
    (function (Status) {
        Status["Pending"] = "pending";
        Status["Complete"] = "complete";
    })(Status = Tasks.Status || (Tasks.Status = {}));
    Tasks.StatusMap = {
        [Status.Pending]: "Pending",
        [Status.Complete]: "Complete"
    };
    Tasks.ModelKeyMap = {
        taskChangelog: "Task Changelog",
        comments: "Comments",
        incidentId: "Incident",
        createdAt: "Creation Time",
        remindAt: "Reminder Time",
        detail: "Detail",
        status: "Status"
    };
    function Defaults() {
        return {
            incidentId: "",
            createdAt: new Date().toISOString(),
            remindAt: null,
            detail: "",
            status: Status.Pending,
            comments: [],
            taskChangelog: []
        };
    }
    Tasks.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        defaults = Defaults;
        relationships = {};
    }
    Tasks.CollectionClass = CollectionClass;
})(Tasks || (Tasks = {}));
//# sourceMappingURL=index.js.map